<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="inherit" stroke="none" />
      <path
        d="M11.5 7h1c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5h-1a.5.5 0 0 1-.5-.5v-6c0-.3.2-.5.5-.5ZM11.3 16.3c.2-.2.4-.3.7-.3.3 0 .5 0 .7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7Z"
        fill="#fff"
        stroke="none"
      />
    </svg>
  </span>
</template>
